

export const METADEFENDER = {
    baseUrl: 'https://api.metadefender.com',
    version: 'v4',
    timeout: 100000,
};
